/* src/app/components/item-view/item-view.component.scss */
:host {
  display: block;
  height: 100%;
}
:host(.item-responsive) .item-row {
  width: 100%;
}
.sold-out {
  position: absolute;
  left: 25px;
  top: 10px;
  z-index: 9999;
}
.sold-out ion-icon {
  height: 30px;
  width: 66px;
  z-index: 99;
}
.item-row {
  height: 254px;
  width: 100%;
  border-radius: 9px;
  position: relative;
  overflow: hidden;
  transition: border 0.2s ease-in-out;
  background: #23262c;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.1);
}
.item-row.inactive {
  opacity: 0.3;
}
.item-row.isAdded {
  border: 2px solid #00FFFF;
}
@media (min-width: 991px) {
  .item-row:hover {
    border: 2px solid rgba(255, 255, 255, 0.2);
  }
}
.item-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.new {
  position: absolute;
  height: 25px;
  width: 60px;
  background-color: var(--ion-color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  top: -8px;
  right: -5px;
  z-index: 1;
  color: #f6f1ef;
  text-transform: uppercase;
  font-size: 80%;
}
.img-wrapper {
  width: 100%;
  height: 100px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-bottom: 8px;
  margin-top: 0;
  flex-shrink: 0;
}
.img-wrapper.block-adding ion-img {
  opacity: 0.3;
}
.img-wrapper.block-adding ion-icon {
  position: absolute;
  top: 10px;
  right: -15px;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 20px;
  height: 20px;
  opacity: 0.3;
}
.item-image {
  width: 100%;
  height: 100px;
  max-width: 100%;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}
.default-image {
  width: 60%;
  height: 60%;
  max-width: 100%;
  --icon-color: var(--color-black);
}
.item-name {
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
  margin-top: 8px;
  margin-bottom: 2px;
  padding-left: 10px;
  padding-right: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 34px;
  max-height: 34px;
}
.item-info {
  font-size: 10px;
  line-height: 130%;
  text-align: center;
  vertical-align: middle;
  color: #D3D3D3;
  margin-bottom: 4px;
  padding-left: 10px;
  padding-right: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 26px;
  max-height: 26px;
}
.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  min-height: 20px;
  flex-shrink: 0;
}
.price-row .divider {
  width: 1px;
  height: 20px;
  background-color: #383838;
}
.price-row .price {
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.price-row .tags {
  display: flex;
  align-items: center;
  gap: 6px;
}
.price-row .tags ion-icon {
  width: 16px;
  height: 16px;
  color: #999;
}
.buttons {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  padding-bottom: 10px;
}
.buttons .add-button-icon {
  width: 32px !important;
  height: 32px !important;
  cursor: pointer;
  transition: transform 0.2s ease;
}
.buttons .add-button-icon:hover {
  transform: scale(1.05);
}
.buttons .add-button-icon:active {
  transform: scale(0.95);
}
.buttons ion-button {
  --border-radius: 50%;
  width: 32px;
  height: 32px;
  --padding-start: 0;
  --padding-end: 0;
  margin: 0;
}
.buttons ion-button ion-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.buttons .add-button {
  min-height: 30px !important;
  height: 30px !important;
}
.buttons .add-button.not-enought {
  opacity: 0.3;
}
.buttons .add-icon-wrap {
  width: 48%;
  display: flex;
  justify-content: flex-start;
}
.buttons .add-icon-wrap.center-align {
  justify-content: center;
}
.buttons .not-enough {
  --color: #fff;
  opacity: 0.5;
}
.buttons .not-enough ion-icon {
  margin-right: 10px;
}
.buttons .quantity-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #383838;
  border: 2px solid #fff;
  border-radius: 20px;
  padding: 4px 8px;
  width: 100%;
  max-width: 120px;
  cursor: pointer;
  height: 32px;
}
.buttons .quantity-selector .quantity-btn-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  min-width: 24px;
  min-height: 24px;
}
.buttons .quantity-selector .quantity-btn-wrapper:hover .quantity-btn {
  transform: scale(1.2);
}
.buttons .quantity-selector .quantity-btn-wrapper:active .quantity-btn {
  transform: scale(0.9);
}
.buttons .quantity-selector .quantity-btn {
  width: 16px;
  height: 16px;
  cursor: pointer;
  transition: transform 0.2s;
  color: #fff;
  flex-shrink: 0;
  pointer-events: none;
}
.buttons .quantity-selector .quantity-text {
  font-size: 12px;
  color: #fff;
  min-width: 18px;
  text-align: center;
  flex: 1;
}
.progress-bar {
  position: absolute;
  bottom: -20px;
  width: 120%;
  --progress-background: #f48b7f;
  --buffer-background: #ebdfda;
}
.add-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ebdfda;
}
.add-icon:hover {
  background: #f2dbd9;
}
.add-icon ion-icon {
  margin: 0px;
  color: var(--color-black);
  width: 40px;
  height: 40px;
}
.amount-in-basket {
  z-index: 999;
  position: absolute;
  display: flex;
  align-items: center;
  border-radius: 20px;
  top: 8px;
  right: 8px;
  margin: 0 auto;
}
.amount-in-basket .selected-text {
  font-size: 8px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: lowercase;
  color: var(--color-black);
  margin-right: 3px;
}
.amount-in-basket .quantity-block {
  height: 20px;
  width: 40px;
  background: #000000;
  border: 1px solid;
  border-radius: 50px;
  border-image-source:
    linear-gradient(
      0deg,
      #ffffff,
      #ffffff),
    linear-gradient(
      0deg,
      #ffffff,
      #ffffff);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.amount-in-basket .quantity-block .quantity {
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
  transform: translate(8px, -3%);
}
.checkmark {
  height: 24px;
  width: 24px;
  position: relative;
  left: 2px;
  scale: 1.03;
}
.discount-badges {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
/*# sourceMappingURL=item-view.component.css.map */
